/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Child } from './child';
import { Legend } from './legend';
import { StemReportTestData } from './stemReportTestData';
import { Test } from './test';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface StemComparisonReportOpenApi { 
    child: Child;
    test: Test;
    testData: Array<StemReportTestData>;
    legend: Array<Legend>;
}